import { FETCH_CATEGORIES_SUCCESS, INITIAL_CATEGORIES_REQUEST } from "../../types/maintainers/categories.type";

const initialState = {
	categories: [],
	customers: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_categories(state = initialState, action) {
	switch (action.type) {
		case INITIAL_CATEGORIES_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case FETCH_CATEGORIES_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				categories: action.payload.categories,
				estates: action.payload.estates,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		default:
			return state;
	}
}

export default maintainers_categories;
